import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PdfTitleComponent } from './pdf-title.component';
import { PdfSpacerModule } from '../pdf-spacer/pdf-spacer.module';


@NgModule({
  declarations: [
    PdfTitleComponent
  ],
  exports: [
    PdfTitleComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PdfSpacerModule
  ],
  providers: []
})
export class PdfTitleModule { }
